import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import language from './english';

i18n.use(LanguageDetector).init({
  // we init with resources
  resources: {
    en: language,
  },
  fallbackLng: 'en',

  // have a common namespace used around the full app
  ns: ['landingPage', 'message'],
  defaultNS: 'landingPage',

  keySeparator: false, // we use content as keys

  interpolation: {
    escapeValue: false, // not needed for react!!
    formatSeparator: ',',
  },

  react: {
    wait: true,
  },
});

export default i18n;
